import { render, staticRenderFns } from "./Galeria.vue?vue&type=template&id=c99b9530&scoped=true&"
import script from "./Galeria.vue?vue&type=script&lang=js&"
export * from "./Galeria.vue?vue&type=script&lang=js&"
import style0 from "./Galeria.vue?vue&type=style&index=0&id=c99b9530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99b9530",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VImg,VProgressCircular,VRow})
